// extracted by mini-css-extract-plugin
module.exports = {"flex":"TaxIncomeSection__flex--1Sk1O","twoElement":"TaxIncomeSection__twoElement--3mymf"};